var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoad = function SvgRoad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747.64,
    height: 402.222,
    viewBox: "0 0 747.64 402.222",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.746,
    x2: 1,
    y2: 0.756,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f32b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#e18b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a31621"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Game_Path",
    "data-name": "Game Path",
    d: "M630.837,1887.35H162.415c-41.179,0-74.561,33.973-74.561,75.88s33.382,75.88,74.561,75.88h374.6l1.668-.095a17.121,17.121,0,0,1,.063,34.242h-.063l-1.64.2H151.333c-58.988,0-106.806-48.664-106.806-108.7s47.818-108.7,106.806-108.7l4.528-.258H670.97c45.428,0,78.811-33.973,78.811-75.88s-33.383-75.88-74.561-75.88H130.835v-32.8H685.361c58.988,0,106.806,48.664,106.806,108.7s-47.823,108.69-106.806,108.69H657.1",
    transform: "translate(-44.527 -1671.235)",
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/road.dd8d433f.svg";
export { ForwardRef as ReactComponent };